import PropTypes from 'prop-types'
import { themr } from '../react-css-themr'
import { LIST } from '../identifiers'

const ListDivider = ({ inset = false, theme }) => (
  <hr className={inset ? `${theme.divider} ${theme.inset}` : theme.divider} />
)

ListDivider.propTypes = {
  inset: PropTypes.bool,
  theme: PropTypes.shape({
    divider: PropTypes.string,
    inset: PropTypes.string,
  }),
}

export default themr(LIST)(ListDivider)
export { ListDivider }
